
import { Placement } from '@post-office/placements-frontend/jira-dev-code-tab-rovodev-adoption';
export default Placement;
